import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { AssetsService } from "app/services/AssetsService";
import {
    FlexColumn,
    CenteredFlexColumn,
    CenteredFlexRow,
} from "pro-features/styled components/StyledFlex/src/StyledFlex";
export const HomepageHeader = styled(CenteredFlexColumn)`
    width: 100%;
`;
export const HomePage = styled.div`
    align-items: center;
    background: url(${AssetsService.assetUrl("/images/trialHomepage.png")}) 0% / cover no-repeat;
    z-index: -1;
    height: 546px;
    @media only screen and (max-width: 1800px) {
        height: 470px;
    }
    @media only screen and (max-width: 1400px) {
        height: 400px;
    }

    &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background:
            url(${AssetsService.assetUrl("/images/common/attach-left.svg")}),
            url(${AssetsService.assetUrl("/images/halfCircleRightTop.svg")});
        background-repeat: no-repeat, no-repeat;
        background-position:
            left top,
            right top;
    }
`;

export const ListExamplesWrapper = styled(CenteredFlexRow)`
    justify-content: space-between;
    margin-bottom: 30px;
`;

export const HomepageInnerWrapper = styled(FlexColumn)`
    max-width: 600px;
    align-items: center;
`;

export const HomepagePreviewInnerWrapper = styled(FlexColumn)`
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
`;

export const BodyWrapper = styled(FlexColumn)`
    z-index: 1;
    width: 600px;
    padding-top: 35px;
    padding-bottom: 50px;
`;

export const HomepageBody = styled(CenteredFlexColumn)`
    width: 100%;
`;

export const HomePageBannerWrapper = styled(CenteredFlexColumn)`
    width: 800px;
    container-name: ai-report-cta-section-wrapper;
    container-type: inline-size;
    margin-left: calc(50% - 400px);
`;

export const TextPopularWebsites = styled.span`
    ${setFontVariant("chip1", colorsPalettes.carbon[300])};
    line-height: 16px;
    margin-right: 16px;
    text-align: center;
`;
export const TitlesHeader = styled(CenteredFlexColumn)`
    padding-top: 100px;
    padding-bottom: 55px;
    width: 100%;
    z-index: 1;
    @media only screen and (max-width: 1400px) {
        padding-top: 90px;
        padding-bottom: 40px;
    }
    @media only screen and (max-width: 1350px) {
        padding-top: 80px;
        padding-bottom: 35px;
    }
    @media only screen and (max-width: 1280px) {
        padding-top: 50px;
        padding-bottom: 35px;
    }
`;
export const TrackerAssetChipItemStyle = styled.div`
    cursor: pointer;
`;
export const HeaderContent = styled(FlexColumn)`
    width: 100%;
    align-items: center;
`;
export const Title = styled.span`
    width: 100%;
    text-align: center;
    line-height: 32px;
    padding-bottom: 8px;
    ${setFontVariant("h4", colorsPalettes.carbon[400])};
    @media only screen and (max-width: 1400px) {
        ${setFontVariant("h5", colorsPalettes.carbon[400])};
    }
    @media only screen and (max-width: 1280px) {
        ${setFontVariant("h6", colorsPalettes.carbon[400])};
        line-height: 24px;
    }
`;
export const SubTitle = styled.span`
    ${setFontVariant("h2", colorsPalettes.carbon[500])};
    line-height: 40px;
    text-align: center;
    @media only screen and (max-width: 1400px) {
        ${setFontVariant("h3", colorsPalettes.carbon[500])};
        line-height: 38px;
    }
    @media only screen and (max-width: 1280px) {
        ${setFontVariant("h4", colorsPalettes.carbon[500])};
        line-height: 32px;
    }
`;
export const AutocompleteWebsiteWrapper = styled.div`
    filter: drop-shadow(0px 18px 34px rgba(14, 30, 62, 0.12));
    width: 600px;
    margin-bottom: 32px;
    z-index: 3;
`;

export const TitlePagePreview = styled.div`
    ${setFontVariant("h6", colorsPalettes.carbon[300])};
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
`;
export const TitlePagePrevieWrapper = styled(CenteredFlexRow)`
    padding-bottom: 48px;
`;
export const LineTitle = styled.div`
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    width: 299px;
    transform: rotate(-180deg);
    @media only screen and (max-width: 1400px) {
        width: 228px;
    }
`;

export const EmptyStateText = styled.div`
    text-align: center;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[300])};
`;

export const TabsContainer = styled.span`
    > div {
        display: inline-block;
        padding-bottom: 16px;
    }
`;
